import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { BaseURL, uniqueToken } from "../../api/DataApis";

const EditBankAccount = () => {
  const { user_id, bank_id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    bank_name: "",
    account_number: "",
    ifsc_code: "",
    account_holder_name: "",
  });

  const [loading, setLoading] = useState(false);

  const fetchBankData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BaseURL}/bank-account/${user_id}`, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      const bankAccounts = response?.data?.data || [];
      const currentBank = bankAccounts.find(acc => acc._id === bank_id);
      if (currentBank) {
        setFormData({
          bank_name: currentBank.bank_name || "",
          account_number: currentBank.account_number || "",
          ifsc_code: currentBank.ifsc_code || "",
          account_holder_name: currentBank.account_holder_name || "",
        });
      }
    } catch (error) {
      console.error("Error fetching bank account:", error);
      Swal.fire("Error", "Failed to load bank account data", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBankData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Updating Bank Account...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await axios.put(
        `${BaseURL}/bank-account/${user_id}/${bank_id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        }
      );

      Swal.close();

      if (response?.data?.statusCode === 200) {
        Swal.fire("Success", "Bank account updated successfully!", "success");
        navigate(-1);
      } else {
        Swal.fire("Error", response?.data?.message || "Update failed", "error");
      }
    } catch (error) {
      console.error("Error updating:", error);
      Swal.fire("Error", error?.response?.data?.message || "Server error", "error");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row justify-content-center mt-4">
        <div className="col-lg-10">
          <div className="card shadow">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="mb-0">Edit Bank Account</h4>
              <button className="btn btn-dark" onClick={() => navigate(-1)}>
                Back
              </button>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <table className="table table-borderless">
                  <tbody>
                    <tr>
                      <th style={{ width: '200px' }}>Bank Name</th>
                      <td>
                        <input
                          type="text"
                          name="bank_name"
                          value={formData.bank_name}
                          onChange={handleChange}
                          className="form-control"
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Account Number</th>
                      <td>
                        <input
                          type="text"
                          name="account_number"
                          value={formData.account_number}
                          onChange={handleChange}
                          className="form-control"
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>IFSC Code</th>
                      <td>
                        <input
                          type="text"
                          name="ifsc_code"
                          value={formData.ifsc_code}
                          onChange={handleChange}
                          className="form-control"
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Account Holder Name</th>
                      <td>
                        <input
                          type="text"
                          name="account_holder_name"
                          value={formData.account_holder_name}
                          onChange={handleChange}
                          className="form-control"
                          required
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="text-start">
                  <button type="submit" className="btn btn-success">
                    Update Bank Account
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBankAccount;